import axios from 'axios';
import { persistStore } from 'redux-persist';
import { store } from '../index';
import * as _ from 'lodash';
import history from '../History';
const apiRoot = process.env.REACT_APP_API_URI || "/api";

export const SET_API = "SET_API", 
    LOGIN_REQUEST = "LOGIN_REQUEST", 
    LOGIN_SUCCESS = "LOGIN_SUCCESS", 
    LOGIN_FAILED = "LOGIN_FAILED",
    REGISTER_REQUEST = "REGISTER_REQUEST",
    REGISTER_ERROR = "REGISTER_ERROR",
    REGISTER_SUCCESS = "REGISTER_SUCCESS",
    API_REQUEST = "API_REQUEST", 
    API_SUCCESS = "API_SUCCESS", 
    API_FAILED = "API_FAILED", 
    LOGOUT = "LOGOUT",
    SET_ERROR = "SET_ERROR",
    CLEAR_ERROR = "CLEAR_ERROR",
    GOT_SERVICES = "GOT_SERVICES";

// Authetication Actions
export const register = newUser => dispatch =>
    new Promise((resolve, reject) => {
        dispatch({type: REGISTER_REQUEST});
        var inputErr = false;

        Object.keys(newUser).forEach(key => {
            console.log(newUser[key]);
            if (!newUser[key] && key !== 'street2') {
                dispatch({type: "REG_INPUT_ERROR", key});
                inputErr = true;
            }
        });

        if (inputErr) {
            reject({response: { status: 400, data: { error: "Missing Required Information."}}});
        } else {
            resolve();
        }
    })
    .then(_ => axios({
        method: "post",
        url: apiRoot + "/auth/register",
        data: newUser
    }))
    .then(response => dispatch({
        type: REGISTER_SUCCESS, 
        status: response.status
    }))
    .catch(error => {
        console.log(error);
        return dispatch({
            type: REGISTER_ERROR, 
            error: error.response.data.error,
            status: error.response.status
        });
    });

export const loginRequest = (email, password) => dispatch => 
    Promise.resolve(dispatch({
        type: LOGIN_REQUEST,
        user: { email, password }
    }))
    .then(_ => axios({
        method: "post",
        url: apiRoot + "/auth/login",
        data: { email, password }
    }))
    .then(response => {
        dispatch({ 
            type: LOGIN_SUCCESS, 
            user: response.data.user, 
            status: response.status 
        });
        history.push('/Dashboard');
    })
    .catch(error => {
        console.log(error);
        return dispatch({type: LOGIN_FAILED});
    });


export const logout = _ => dispatch => axios({ 
    method: "delete", 
    url: apiRoot + "/auth/login" 
})
.then(dispatch({ type: LOGOUT }));

export const resetPassword = email => dispatch => axios({
    method: "post", 
    url: apiRoot + "/forgot", 
    data: {email}
})
.then(() => dispatch({type: "PASSWORD_RESET", email}));

export const updateUser = updatedUser => dispatch => console.log("Update user");

// Service Actions
export const fetchServices = () => dispatch => axios({
    method: 'get',  
    url: apiRoot + '/services'
})
.then(response => response.data)
.then(services => dispatch({ type: GOT_SERVICES, services }));

export const quoteRequest = (service, user) => dispatch => 
Promise.resolve(dispatch({type: "QUOTE_REQUEST"}))
.then(axios({
    method: "post",
    url: apiRoot + "/getQuote",
    data: {service, user}
}))
.then(_ => dispatch({type: "QUOTE_SUCCESS"}))
.then(_ => dispatch({type: "ADD_SERVICE", service}))
.catch(error => dispatch({type: "QUOTE_FAIL", error}));


// WEBPACK FOOTER //
// ./src/redux/actions.js